<template>
  <div class="page-bg">
    <mt-header fixed title="我的">
      <router-link to="" slot="left">
        <mt-button icon="back" @click.native="$router.back(-1)"></mt-button>
      </router-link>
    </mt-header>
    <div class="info-bg">
      <div class="user-pannel clearfix">
        <div class="user-face">
          <img v-if="!isXyk" src="@assets/images/aboutUs/HeadPicture.png" />
          <img v-else src="@assets/ql_logo.png" />
        </div>
        <div>
          <div class="txt-gray userId">{{ userId }}</div>
          <div class="txt-gray-lighter userState">
            <img class="icon" src="@assets/images/aboutUs/already.png" alt />
            <p v-if="userState == '2'">已实名认证</p>
            <p v-else>未完成实名认证</p>
          </div>
        </div>
      </div>
      <div class="menu">
        <div class="menu-itme">
          <img src="@assets/images/aboutUs/userinfo.png" alt="" />
          <mt-cell
            title="个人信息"
            to="/aboutUs/userInfo"
            is-link
            value
          ></mt-cell>
        </div>
        <div class="menu-itme">
          <img src="@assets/images/aboutUs/Finance.png" alt="" />
          <mt-cell
            title="账务明细"
            to="/user/turnover-list"
            is-link
            value
          ></mt-cell>
        </div>
        <div class="menu-itme">
          <img src="@assets/images/aboutUs/question.png" alt="" />
          <mt-cell
            title="问题FAQ"
            to="/aboutUs/questions"
            is-link
            value
          ></mt-cell>
        </div>
        <div class="menu-itme">
          <img src="@assets/images/aboutUs/service.png" alt="" />
          <mt-cell
            title="联系客服"
            to="/aboutUs/contact"
            is-link
            value
          ></mt-cell>
        </div>
        <div class="menu-itme">
          <img src="@assets/images/aboutUs/about.png" alt="" />
          <mt-cell title="关于" to="/aboutUs/intro" is-link value></mt-cell>
        </div>
        <!-- <mt-cell title="解绑微信" @click.native="handleUntieWeChat"></mt-cell> -->
        <div class="menu-itme">
          <img src="@assets/images/aboutUs/exit.png" alt="" />
          <mt-cell title="退出" @click.native="Cancellation" value></mt-cell>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Cancellation, getUserInfo } from "@api/user";
import { unitWeChat } from "@api/login";
import { Toast } from "mint-ui";
export default {
  data() {
    return {
      userId: this.$store.getters.getUser.phone,
      userState: this.$store.getters.getUser.state,
      isXyk: window.location.origin.indexOf("h5.jzbase-saas") > -1,
    };
  },
  methods: {
    Cancellation() {
      //注销
      const authorization = this.$store.getters.getUser.authorization;
      const userNo = this.$store.getters.getUser.userId;
      if (
        authorization == undefined ||
        authorization == "" ||
        authorization == null
      )
        return;
      if (userNo == undefined || userNo == "" || userNo == null) return;
      let data = {
        authorization: authorization,
        userId: userNo,
      };
      // 注销接口
      Cancellation(data)
        .then((res) => {
          if (!res.data) {
            //处理失败
            this.err.code = res.data.message;
            Toast(res.data.message);
            return;
          }
          this.$store.commit("logout");
          this.$router.push("/login");
        })
        .catch((err) => {});
    },
    handleUntieWeChat() {
      unitWeChat().then((res) => {
        if (res.code === 200) {
          Toast("解绑微信成功");
        } else {
          Toast(res.message);
        }
      });
    },
  },
  mounted() {
    let data = {
      userNo: this.$store.getters.getUser.userId,
      Authorization: this.$store.getters.getUser.authorization,
    };
    getUserInfo(data)
      .then((res) => {
        if (res.code === 200) {
          const { data } = res;
          this.userId = data.userMobile;
          this.userState = data.state;
          const userInfo = {
            ...this.$store.getters.getUser,
            state: data.state,
          };
          this.$store.commit("setUser", userInfo);
          sessionStorage.setItem("user", JSON.stringify(userInfo));
        }
      })
      .catch((err) => {});
  },
};
</script>
<style lang="less" scoped>
.page-bg {
  background: url("./../../assets/images/currency.png") no-repeat;
  background-size: 100% 100%;
  background-position: 0 0;
  height: 100%;
  padding-top: 50px;
}
.info-bg {
  background: url("../../assets/images/aboutUs/info_bg.png") no-repeat;
  background-size: 100% 110%;
}
.user-pannel {
  margin: 20px;
  // background-color: #fff;
  border-radius: 8px;
  padding: 28px 0;
  // box-shadow: 0px 0px 15px 7px rgba(0, 0, 0, 0.1);
}
.user-face {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  background-color: #eee;
  float: left;
  margin-right: 15px;
}
.userId {
  padding-top: 5px;
  margin-bottom: 5px;
  font-weight: 700;
}
.userState {
  font-size: 0.8rem;
  height: 1.5rem;
  line-height: 1.5rem;
}
.icon {
  width: 1.5rem;
  height: 1.5rem;
  display: inline-block;
  float: left;
  margin-right: 5px;
}
.menu {
  padding: 15px 15px 15px 15px;
  a,
  * {
    color: #333;
  }
}
.mint-cell-allow-right::after {
  width: 8px;
  height: 8px;
  // -webkit-transform: translateY(-50%) rotate(45deg);
  // transform: translateY(-50%) rotate(45deg);
  // background: url("../../assets/images/aboutUs/left.png") no-repeat;
  // background-size: 100% 100%;
}
.menu-itme {
  display: flex;
  align-items: center;
  padding: 5px 20px;
}
.menu-itme img {
  width: 20px;
  height: 20px;
}
</style>
